import React from "react";
import { Contact, Footer, Navbar } from "../components";

const ContactPage = () => {
  return (
    <div>
      <Navbar />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;
